import { Tier } from '@backrs_ui/common-ui';

import { CareerUserResponseSet, CareerQuestion } from '@backrs_ui/grow-ui/src/models/models';

import { Page, View } from '@react-pdf/renderer';

import { resultPageStyles } from './resultPDF.styles';
import { AspirationsExplanationsPDF } from '../atoms/AspirationsExplanationsPDF';
import { MinimumTrackExplanationPDF } from '../atoms/MinimumTrackExplanationPDF';
import { MinimumTrackHeaderPDF } from '../atoms/MinimumTrackHeaderPDF';

type PageOneProps = Readonly<{
  tier: Tier;
  entrepreneurshipRecommended: boolean;
  firstName?: string;
  lastName?: string;
  createdAt: string;
  userResponseSet: CareerUserResponseSet;
  careerQuestions: CareerQuestion[];
}>;

export function ResultPageOne({
  tier,
  entrepreneurshipRecommended,
  firstName,
  lastName,
  createdAt,
  userResponseSet,
  careerQuestions,
}: PageOneProps) {
  return (
    <Page size="LETTER" style={resultPageStyles.pageFont}>
      <View style={resultPageStyles.minimumTrackHeaderContainer}>
        <View style={{ width: '100%' }}>
          <MinimumTrackHeaderPDF
            minimumTrack={tier}
            fullName={firstName || lastName ? `${firstName} ${lastName}` : undefined}
            createdAt={createdAt}
          />
        </View>
      </View>
      <View style={resultPageStyles.trackExplanationAspirationsContainer}>
        <View style={{ width: '68%' }}>
          <MinimumTrackExplanationPDF
            minimumTrack={tier}
            entrepreneurshipRecommended={entrepreneurshipRecommended}
          />
        </View>
        <View style={{ width: '32%' }}>
          <AspirationsExplanationsPDF
            userResponseSet={userResponseSet}
            questions={careerQuestions}
          />
        </View>
      </View>
    </Page>
  );
}
